import { useState, useEffect } from 'react';
import Topbar from '../layouts/Topbar';
import Grid from "@mui/material/Grid2";
import Image from "../../Utils/getImage";
import {
    Dialog, Button, DialogActions, FormControl, InputAdornment, Tabs, Tab, MenuItem,
    Select, TextField, Typography, IconButton, DialogTitle, DialogContent, Box,
    CircularProgress,
} from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from "dayjs";
import instance from '../../Utils/api';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import SubOrder_details from '../components/subOrder_details';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const Orderinfo = () => {
    const { order_id } = useParams();
    const [adminId, setadminId] = useState('')
    const [deadline, setDeadline] = useState(null);
    const [status, setstatus] = useState('');
    const [amount, setAmount] = useState(null);
    const [documents, setDocuments] = useState(null);
    const [finalImage, setFinalImage] = useState(null);
    const [suborderDetails, setsuborderDetails] = useState([]);
    const [juniorAdmins, setJuniorAdmins] = useState([]);
    const [seniorAdmins, setSeniorAdmins] = useState([]);
    const [orderAdminId, setOrderAdminId] = useState('');
    const [paymentAmount, setpaymentAmount] = useState('')
    const [discount, setDiscount] = useState('');
    const [staff, setStaff] = useState([])
    const [payments, setPayments] = useState();
    const [paymentMode, setPaymentMode] = useState('Online');
    const [openConsultationDialog, setOpenConsultationDialog] = useState(false);
    const [openRefundDialog, setOpenRefundDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [consultation, getConsultations] = useState();
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false)
    const [refundData, setRefundData] = useState({
        amount: "",
        Teans_id: ""
    });
    const navigate = useNavigate();
    const role = localStorage.getItem('role');

    const handleRefundSubmit = async () => {
        if (!refundData?.amount) {
            return toast.error("Refund Amount is Required");
        }
        try {

            const response = await instance.patch('/Payment/manualRefund', {
                amount: refundData.amount,
                TransactionId: refundData.Teans_id,
                order_id: order_id
            });
            if (response.data.success === true) {
                toast.success(response.data.message);
                fetchSubOrderDetailsById();
                fetchPayments();
                handleClose2();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            console.log("error", error);
        }
    }

    const handelRaiseConsultation = (id) => {
        setSelectedId(id);
        setOpenConsultationDialog(true);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const formatAddress = (address) => {
        if (!address) return { line1: 'N/A', line2: 'N/A', line3: 'N/A' };
        return {
            line1: `${address.line_1 || ''}, ${address.line_2 || ''}`,
            line2: `${address.city || ''}, ${address.state || ''}`,
            line3: `${address.pincode || ''}`,
        };
    };

    const fullAddress = formatAddress(suborderDetails?.address);

    const handleClose = () => {
        setOpenConsultationDialog(false);
        setSelectedId(null);
    };
    const handleClose2 = () => {
        setOpenRefundDialog(false);
        setRefundData({
            amount: "",
            Teans_id: ""
        })
    };
    const handleraiseConsultation = async () => {
        try {
            const response = await instance.post('/Consultation/raiseConsultation', {
                order_id: order_id,
                customer_id: suborderDetails?.customer_id?._id,
                name: suborderDetails?.address?.name,
                phone: suborderDetails?.address?.mobile,
                assign: true
            });
            if (response.data.success === true) {
                toast.success(response?.data?.message);
                handleClose();
                navigate('/admin/consultation')
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    //fetch admins
    const fetchadmins = async () => {
        try {
            const response = await instance.get('/Admin/getAdmins')

            // Filter Junior Designers
            const juniorFilter = response?.data?.data?.filter(admin => admin.role === 'JuniorDesigner');
            const juniorFormatted = juniorFilter?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeImage: employee?.profile_pic
            }));

            // Filter Senior Designers
            const seniorFilter = response?.data?.data?.filter(admin => admin.role === 'SeniorDesigner');
            const seniorFormatted = seniorFilter?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeImage: employee?.profile_pic
            }));

            setJuniorAdmins(juniorFormatted);
            setSeniorAdmins(seniorFormatted);
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        }

    }

    //fetch admins
    const fetchStaff = async () => {
        const params = {
            Status: true
        }
        try {
            const response = await instance.get('/Staff/getStaff', { params });
            const formatteddata = response?.data?.data?.map((employee, index) => ({
                sno: index + 1,
                staffId: employee?._id,
                Name: employee?.Name,
                Designation: employee?.Designation?.Designation,
                DesignationName: employee?.Name,
            }))
            setStaff(formatteddata);
        }
        catch (error) {
            console.log("error to fetch staff:", error.message)
        }

    }

    //fetch admins
    const fetchPayments = async () => {
        try {
            const response = await instance.get(`/Payment/getPaymentByOrderId?OrderId=${order_id}`);
            setPayments(response?.data?.data);
        }
        catch (error) {
            console.log("error to fetch staff:", error.message)
        }

    }
    useEffect(() => {
        fetchadmins();
        fetchStaff();
        fetchPayments();
    }, [])

    const fetchSubOrderDetailsById = async () => {
        try {
            const response = await instance.get(`/Order/OrderById?order_id=${order_id}`);
            setsuborderDetails(response?.data?.data);
            setDiscount(response.data.data.discount || '');
        } catch (error) {
            console.error("Error fetching suborder details:", error.message);
        }
    };

    // Fetch suborder details by ID
    useEffect(() => {
        fetchSubOrderDetailsById();
    }, [order_id]);


    const handleupdateorder = async (order_id) => {
        const formData = new FormData();
        formData.append("order_id", order_id);
        // Track if any field is updated
        let isUpdated = false;

        if (status && status !== suborderDetails?.status) {
            formData.append("status", status);
            isUpdated = true;
        }
        if (adminId && adminId !== suborderDetails?.assigned_to?._id) {
            formData.append("admin_id", adminId);
            isUpdated = true;
        }
        if (deadline && deadline !== suborderDetails?.deadline) {
            formData.append("deadline", deadline);
            isUpdated = true;
        }
        if (amount && amount !== suborderDetails?.amount) {
            formData.append("amount", amount);
            isUpdated = true;
        }
        if (documents instanceof File) { // Ensure it's a valid file
            formData.append("documents", documents);
            isUpdated = true;
        }
        if (finalImage instanceof File) { // Ensure it's a valid file
            formData.append("final_image", finalImage);
            isUpdated = true;
        }

        // Stop if no changes were made
        if (!isUpdated) {
            toast.info("No changes made.");
            return;
        }
        try {
            const response = await instance.patch('/Order/updateSubOrder', formData);

            if (response.data.success === true) {
                toast.success(response.data.message);
                fetchSubOrderDetailsById()
            } else {
                toast.error(response.data.message || "Amount must be greater than previous amount")
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Amount must be greater than previous amount")
        }
    }

    const handleRefund = async (merchantTransactionId, Amount) => {
        try {
            const response = await instance.post('/Payment/PaymentRefund', {
                merchantTransactionId,
                Amount
            });
            if (response.data.success === true) {
                toast.success(response.data.message);
                fetchPayments();
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleRefundstatus = async (Refund_merchantTransactionId) => {
        try {
            const response = await instance.get(`/Payment/RefundStatus?Refund_merchantTransactionId=${Refund_merchantTransactionId}`);
            if (response.data.success === true) {
                toast.success(response.data.message);
                fetchPayments();
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleOrder = async (order_id) => {
        if (paymentAmount && !paymentMode) {
            return toast.error("Please select payment mode");
        }
        try {
            setLoading(true)
            const response = await instance.patch('/Order/updateOrder',
                {
                    order_id,
                    admin_id: orderAdminId,
                    payment_amount: paymentAmount,
                    paymentMode: paymentMode,
                    discount: discount
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message);
                fetchSubOrderDetailsById();
                fetchPayments();
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        setOrderAdminId(suborderDetails?.assigned_to?._id)
        // setDiscount(suborderDetails?.assigned_to?._id)
    }, [suborderDetails]);

    const handlegetConsultation = async (suborderDetails) => {
        try {
            const response = await instance.get(`/Consultation/getConsultations/${suborderDetails._id}`);
            getConsultations(response.data)
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        handlegetConsultation(suborderDetails);
    }, [suborderDetails]);

    const formatAmount = (value) => {
        return value ? Number(value).toFixed(2) : "0.00";
    };

    return (
        <>
            <Topbar />
            <section className='order-info-section'>
                <div className='order-info'>
                    <div className="add-employee-title">
                        <div className='order-info-header'>
                            <Typography>Order Info</Typography>
                            <div className='order-info-subheader'>
                                {consultation?.found === true ? <Button onClick={() => navigate('/admin/consultation')}>View Consultation</Button> :
                                    <Button onClick={() => handelRaiseConsultation(suborderDetails?._id)}>Raise Consultation</Button>}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Typography variant='h5'>Customer Details</Typography>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        }}
                    >
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                            <div className="add_emloyee-upload-file">
                                <Image src={suborderDetails.customer_id?.profile_pic} alt="profile_pic" width={220} height={171} />
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                <div className="add_emloyee-content" style={{ marginBottom: "5px" }}>
                                    <div className="add_emloyee-content-text-2">
                                        <Typography variant="h5">Name</Typography>
                                        <Typography>{suborderDetails?.address?.name}</Typography>
                                    </div>
                                    <div className="add_emloyee-content-text-2">
                                        <Typography variant="h5">Address</Typography>
                                        <Typography>{suborderDetails?.address?.line_1 + ',' + suborderDetails?.address?.line_2}</Typography>
                                        <Typography>{suborderDetails?.address?.city + ',' + suborderDetails?.address?.state}</Typography>
                                        <Typography>{suborderDetails?.address?.country + ',' + suborderDetails?.address?.pincode}</Typography>
                                    </div>
                                    <div className="add_emloyee-content-text-2">
                                        <Typography variant="h5">Mobile number</Typography>
                                        <Typography>{suborderDetails?.address?.mobile}</Typography>
                                    </div>
                                </div>
                            </Grid>

                        </Grid>
                    </Grid>
                </div>
                <div className="order-details-title">
                    <Typography variant='h5'>Order Details</Typography>
                </div>
                <>
                    <Grid
                        container
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        }}
                    >
                        {suborderDetails?.sub_orders?.map((subOrder, index) => (
                            <SubOrder_details subOrder={subOrder} index={index} juniorAdmins={juniorAdmins} fetchSubOrderDetailsById={fetchSubOrderDetailsById} staff={staff} payments={payments} />
                        ))}
                    </Grid>
                </> */}
                <Box className="payment-details-container-v4">
                    {/* Tabs for switching between History and Summary */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="payment details tabs">
                            <Tab label="Customer Details" />
                            <Tab label="Order Details" />
                            <Tab label="Transaction History" />
                            <Tab label="Payment Summary" />
                        </Tabs>
                    </Box>

                    {/* Panel 1: Customer Details (New) */}
                    <TabPanel value={tabValue} index={0}>
                        <Box className="customer-details-content">
                            <Image
                                src={suborderDetails.customer_id?.profile_pic}
                                alt={suborderDetails?.address?.name}
                                className="customer-avatar"
                                width={150}
                                height={150}
                            >
                                {suborderDetails?.address?.name?.charAt(0)}
                            </Image>
                            <div className="customer-info">
                                <dl className="info-list">
                                    <div className="info-item">
                                        <dt>Name</dt>
                                        <dd>{suborderDetails?.address?.name || 'N/A'}</dd>
                                    </div>
                                    <div className="info-item">
                                        <dt>Mobile</dt>
                                        <dd>{suborderDetails?.address?.mobile || 'N/A'}</dd>
                                    </div>
                                    <div className="info-item address-item">
                                        <dt>Shipping Address</dt>
                                        <dd>
                                            {fullAddress.line1}
                                            <br />
                                            {fullAddress.line2}
                                            <br />
                                            {fullAddress.line3}
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                        </Box>
                    </TabPanel>
                    {/* Panel 2: Order Details (New) */}
                    <TabPanel value={tabValue} index={1}>
                        {suborderDetails?.sub_orders?.map((subOrder, index) => (
                            <SubOrder_details subOrder={subOrder} index={index} juniorAdmins={juniorAdmins} fetchSubOrderDetailsById={fetchSubOrderDetailsById} staff={staff} payments={payments} />
                        ))}
                    </TabPanel>

                    {/* Panel 3: Transaction History */}
                    <TabPanel value={tabValue} index={2}>

                        <Box className="transaction-table">
                            <div className="table-header">
                                <div>Transaction ID</div>
                                <div>Amount</div>
                                <div>Mode</div>
                                <div>Date</div>
                                <div>Status</div>
                                {/* <div>Actions</div> */}
                            </div>
                            {payments?.map((data) => (
                                <div className="table-row" key={data?.merchant_Transaction_Id}>
                                    <div>{data?.merchant_Transaction_Id || "N/A"}</div>
                                    <div>₹{data?.amount || "0"}</div>
                                    <div>{data?.paymentMode || "---"}</div>
                                    <div>{new Date(data?.createdAt).toLocaleDateString()}</div>
                                    <div>
                                        <span
                                            style={{
                                                backgroundColor: (() => {
                                                    switch (data?.status) {
                                                        case "Done":
                                                            return "#E1FCEF"; // light green
                                                        case "Failed":
                                                            return "#FCEBEA"; // light red/pink
                                                        case "Pending":
                                                            return "#FFF4E5"; // light yellow/orange
                                                        default:
                                                            return "#F0F0F0"; // fallback gray
                                                    }
                                                })(),
                                                color: (() => {
                                                    switch (data?.status) {
                                                        case "Done":
                                                            return "#137333"; // dark green
                                                        case "Failed":
                                                            return "#D93025"; // dark red
                                                        case "Pending":
                                                            return "#FF8C00"; // dark yellow/orange
                                                        default:
                                                            return "#000000"; // fallback black
                                                    }
                                                })(),
                                                // padding: "4px 8px",
                                                // borderRadius: "4px",
                                                // fontWeight: "500",
                                                // fontSize: "14px",
                                            }}
                                            className={`status-chip status-${data?.status?.replace(/\s+/g, '-')}`}
                                        >
                                            {data?.status || "Unknown"}
                                        </span>
                                    </div>

                                    {/* <div className="action-cell">
                                        {data?.status === 'Done' && data?.paymentMode === 'Online' && (
                                            <Button size="small" className="action-btn refund" onClick={() => handleRefund(data.merchant_Transaction_Id, data.amount)}>Refund</Button>
                                        )}
                                        {data.status === 'Refund Initiated' && data?.paymentMode === 'Online' && (
                                            <Button size="small" className="action-btn reload" onClick={() => handleRefundstatus(data.Refund_merchant_Transaction_Id)}>Reload</Button>
                                        )}
                                    </div> */}
                                </div>
                            ))}
                            {payments?.length === 0 && <Typography sx={{ p: 2, textAlign: 'center' }}>No transactions to display.</Typography>}
                        </Box>
                    </TabPanel>

                    {/* Panel 4: Payment Summary */}
                    <TabPanel value={tabValue} index={3}>
                        <dl className="summary-list">
                            <div className="summary-item">
                                <dt>Actual Amount</dt>
                                <dd>₹{formatAmount(suborderDetails?.Actual_price)}</dd>
                            </div>

                            <div className="summary-item">
                                <dt>Total Amount</dt>
                                <dd>₹{formatAmount(suborderDetails?.total_amount)}</dd>
                            </div>

                            <div className="summary-item">
                                <dt>Paid Amount</dt>
                                <dd>₹{formatAmount(suborderDetails?.paid_amount)}</dd>
                            </div>

                            <div className="summary-item">
                                <dt>Remaining</dt>
                                <dd>₹{formatAmount(suborderDetails?.pending_amount)}</dd>
                            </div>

                            <div className="summary-item">
                                <dt>Raised Amount</dt>
                                <dd>₹{formatAmount(suborderDetails?.payment_amount)}</dd>
                            </div>

                            <div className="summary-item">
                                <dt>Discount</dt>
                                <dd>
                                    ₹{formatAmount(suborderDetails?.Discount_price)}/{suborderDetails?.discount || 0}%
                                </dd>
                            </div>

                            <div className="summary-item">
                                <dt>GST</dt>
                                <dd>
                                    ₹{formatAmount(suborderDetails?.gst_price)}/{suborderDetails?.gst || 0}%
                                </dd>
                            </div>

                        </dl>
                    </TabPanel>

                    {/* Always-visible Admin Actions section */}
                    <Box className="admin-actions-card">
                        <Box className="admin-action-header">
                            <Typography variant="h6" className="actions-title">Update Order</Typography>
                            {role === 'Admin' ? <Button variant="contained" className="refund-btn" onClick={() => setOpenRefundDialog(true)} >Refund</Button> : null}
                        </Box>
                        <Grid container spacing={3} alignItems="flex-end">
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Typography component="label" className="form-label">Assign to Sr. Designer</Typography>
                                    <Select value={orderAdminId} onChange={(e) => setOrderAdminId(e.target.value)}>
                                        {seniorAdmins.map((admin) => (
                                            <MenuItem key={admin.employeeId} value={admin.employeeId}>{admin.employeeName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <Typography component="label" className="form-label">Set Discount (%)</Typography>
                                {/* <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={discount}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={(e) => {
                                        let value = Number(e.target.value);
                                        if (value < 0) value = 0;
                                        if (value > 100) value = 100;
                                        setDiscount(value);
                                    }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        min: 0, max: 100
                                    }}
                                /> */}
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={discount}
                                    onWheel={(e) => e.target.blur()}
                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, "") }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (value === "") {
                                            setDiscount("");
                                            return;
                                        }
                                        value = Number(value);
                                        if (value < 0) value = 0;
                                        if (value > 100) value = 100;
                                        setDiscount(value);
                                    }}

                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                    }}
                                />

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <Typography component="label" className="form-label">Amount to Pay (%)</Typography>
                                {/* <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={paymentAmount}
                                    onChange={(e) => {
                                        let value = Number(e.target.value);
                                        if (value < 0) value = 0;
                                        if (value > 100) value = 100;
                                        setpaymentAmount(value);
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        min: 0, max: 100
                                    }}
                                /> */}
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={paymentAmount}
                                    onWheel={(e) => e.target.blur()}
                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (value === "") {
                                            setpaymentAmount("");
                                            return;
                                        }
                                        value = Number(value);
                                        if (value < 0) value = 0;
                                        if (value > 100) value = 100;

                                        setpaymentAmount(value);
                                    }}

                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">%</InputAdornment>
                                        ),
                                    }}
                                />

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Typography component="label" className="form-label">Payment Mode</Typography>
                                    <Select value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)}>
                                        <MenuItem value="Online">Online</MenuItem>
                                        <MenuItem value="Cash">Cash</MenuItem>
                                        <MenuItem value="Card">Card</MenuItem>
                                        <MenuItem value="UPI/QR">UPI/QR</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Box sx={{ mt: 3, textAlign: 'right' }}>
                            <Button variant="contained" className="main-action-btn" disabled={loading} onClick={() => handleOrder(order_id)} sx={{ width: "200px" }}>
                                {(paymentMode === "Online") && (paymentAmount)
                                    ? (loading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Send Payment Link")
                                    : "Update"}
                            </Button>
                            {/* <Button className="main-action-btn" onClick={() => handleOrder(order_id)}>{paymentAmount ? "Send Payment Link" : "save"}</Button> */}
                        </Box>

                    </Box>

                </Box >
            </section >

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openConsultationDialog}
                className="admin-admins">
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {"Raise Consultation"}
                    <div className="consultation-popup"></div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Typography variant='h5' align='center'>Are you sure you want to Raise consultation?</Typography>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className="cancel-btn">Cancel</Button>
                    <Button className="add-btn" onClick={() => {
                        // perform action here
                        handleraiseConsultation();
                    }} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </BootstrapDialog>

            <BootstrapDialog
                onClose={handleClose2}
                aria-labelledby="customized-dialog-title"
                open={openRefundDialog}
                className="Refund-Box"><DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Refund
                    <div className="consultation-popup"></div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose2}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-consultantation">
                        <Grid container spacing={3} alignItems="flex-end">
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }} className="info-item">
                                <Typography component="label" >Paid Amount :</Typography>
                                <Typography>{suborderDetails.paid_amount}</Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                <Typography component="label" className="form-label">Enter Refund Amount*</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={refundData?.amount}
                                    onChange={(e) => {
                                        let value = Number(e.target.value);
                                        if (value < 0) value = 0;
                                        if (value > suborderDetails?.paid_amount) value = suborderDetails.paid_amount;
                                        setRefundData({ ...refundData, amount: value });
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                <Typography component="label" className="form-label">Enter Transaction Id</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="text"
                                    value={refundData?.Teans_id}
                                    onChange={(e) => {
                                        setRefundData({ ...refundData, "Teans_id": e.target.value });
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose2} className="cancel-btn">Cancel</Button>
                    <Button className="add-btn" onClick={() => {
                        handleRefundSubmit();
                    }} autoFocus >
                        Confirm
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default Orderinfo;